import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, RouterModule } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { TabsModule } from 'primeng/tabs';
import { TextCasePipe } from '../../../../../../@shared/pipes/textCase.pipe';

interface IReviewTab {
    label: string;
    routerLink: string;
    icon?: string;
    img?: string;
}

@Component({
    selector: 'app-clause-library-review-tabs',
    imports: [
        RouterOutlet,
        RouterModule,
        TabsModule,
        CommonModule,
        TextCasePipe
    ],
    standalone: true,
    providers: [ConfirmationService],
    templateUrl: './clause-library-review-tabs.component.html',
    styleUrl: './clause-library-review-tabs.component.scss'
})
export class ClauseLibraryReviewTabsComponent implements OnInit {
    TABS_KEYS = {
        REVIEW: 'REVIEW',
        DUPLICATE: 'DUPLICATE',
    };
    TABS: { [key: string]: IReviewTab } = {
        [this.TABS_KEYS.REVIEW]: {
            label: 'Review list',
            routerLink: 'review-clauses',
        },
        [this.TABS_KEYS.DUPLICATE]: {
            label: 'Duplicate clauses',
            routerLink: 'duplicate-clauses',
        }
    };
    tabs: IReviewTab[] = [];

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.tabs = [
            this.TABS[this.TABS_KEYS.REVIEW],
            this.TABS[this.TABS_KEYS.DUPLICATE]
        ];
    }

    goBack() {
        this.router.navigate(['/settings/library/clause-library']);
    }

    isActive(routerLink: string): boolean {
        return this.router.url.includes(routerLink);
    }

    getActiveTabValue(): string {
        const currentUrl = this.router.url;
        const tabIndex = this.tabs.findIndex(tab => currentUrl.includes(tab.routerLink));
        return tabIndex >= 0 ? tabIndex.toString() : '0';
    }
}
